import {DimensionType} from '@/dimensions/Dimension'

export const dimensionColor = (type: DimensionType): string => {
    switch (type) {
        case DimensionType.PROJECT: {
            return 'bg-[#76b7b2]'
        }
        case DimensionType.DEPARTMENT: {
            return 'bg-[#af7aa1]'
        }
        case DimensionType.TAG: {
            return 'bg-[#e15759]'
        }
        case DimensionType.SYSTEM: {
            return 'bg-[#e15759]'
        }
    }
}

export const dimensionTypeText = (type: DimensionType): string => {
    switch (type) {
        case DimensionType.PROJECT: {
            return 'Prosjekt'
        }
        case DimensionType.DEPARTMENT: {
            return 'Avdeling'
        }
        case DimensionType.TAG: {
            return 'Tag'
        }
        case DimensionType.SYSTEM: {
            return 'System'
        }
    }
}

export const dimensionTypeIcon = (type: DimensionType) => {

    switch (type) {
        case DimensionType.PROJECT: {
            return 'i-ph-clipboard'
        }
        case DimensionType.DEPARTMENT: {
            return 'i-ph-cube'
        }
        case DimensionType.TAG: {
            return 'i-ph-tag-fill'
        }
        case DimensionType.SYSTEM: {
            return 'i-ph-robot'
        }
    }
}